(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reset-share-link')) {
    customElements.define('reset-share-link', class extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[data-share-button]');
      this.status = this.querySelector('[data-share-status]');
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      window.clearTimeout(this.statusTimer);
    }

    async getShareUrl() {
      if (this.dataset.shareMode !== 'cart') return window.location.href;

      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error('Cart request failed');

      const cart = await response.json();
      if (!cart.items.length) throw new Error('Cart is empty');

      const quantities = new Map();
      cart.items.forEach((item) => {
        quantities.set(item.variant_id, (quantities.get(item.variant_id) || 0) + item.quantity);
      });

      const cartPath = Array.from(quantities)
        .map(([variantId, quantity]) => `${variantId}:${quantity}`)
        .join(',');

      const cartUrl = new URL(`${root}cart/${cartPath}`, window.location.origin);
      cartUrl.searchParams.set('storefront', 'true');
      return cartUrl.href;
    }

    async copyUrl(url) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        return;
      }

      const field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }

    showStatus(message) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.classList.add('is-visible');
      window.clearTimeout(this.statusTimer);
      this.statusTimer = window.setTimeout(() => {
        this.status.classList.remove('is-visible');
      }, 2600);
    }

    async handleClick() {
      if (!this.button) return;
      this.button.disabled = true;

      try {
        const url = await this.getShareUrl();
        const shareData = {
          title: this.dataset.shareTitle || document.title,
          text: this.dataset.shareText || '',
          url,
        };

        if (navigator.share) {
          try {
            await navigator.share(shareData);
            this.showStatus(this.dataset.shareSuccess || 'Shared');
            return;
          } catch (error) {
            if (error?.name === 'AbortError') return;
          }
        }

        await this.copyUrl(url);
        this.showStatus(this.dataset.shareCopied || 'Link copied');
      } catch (error) {
        if (error?.name !== 'AbortError') {
          this.showStatus(this.dataset.shareError || 'Unable to share right now');
        }
      } finally {
        this.button.disabled = false;
      }
    }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
